import GoogleMapReact from 'google-map-react';
import React from "react";
import Fade from "react-reveal/Fade";
import {
  Col, Container, Row
} from "reactstrap";
import Logo from "../../static/img/fischer_logo.png";
import CallButton from "../components/CallButton";
import CallToButtonNeg from '../components/CallToButtonNeg';
import ContactForm from "../components/contactform";
import Metadata from "../components/Metadata";

const AnyReactComponent = ({ image }) => <div><img width="50px" src={Logo} /></div>;

export const KontaktPageTemplate = ({
  title,
  description,
  heading,
  address,
  times,
  map,
  calltobutton
}) => {
  return (
    <Container className="body__main">
      <Metadata title={title} description={description} meta={[
          {'charSet': 'utf-8'}]} />
      <Row>
        <Fade>
          <Col>
            <h1 className="mainheader">{heading}</h1>
          </Col>
        </Fade>
      </Row>
      <Fade>
        <Row>
          <Col md="6">
            <div className="h-card">
              <address className="contact__address">
                <a className="p-name u-url" href="http://www.fischermarmor.de">
                  {address.name}
                </a>
                <br />
                <span className="p-street-address">{address.street}</span>
                <br />
                <span className="p-postal-code">
                  {address.postcode}
                </span>&nbsp;<span className="p-locality">{address.city}</span>
                <br />
                <span className="p-country-name">Germany</span>
                <br />
                <br />
                Tel.{" "}
                <a href={"tel:" + address.phone} className="p-tel">
                  {address.phone}
                </a>
                <br />
                Fax <span>{address.fax}</span>
                <br />
                <br />
                <a className="u-email" href={"mailto:" + address.mail}>
                  {address.mail}
                </a>
                <br />
                <a className="u-url" href={"http://" + address.website}>
                  {address.website}
                </a>
              </address>
            </div>
            <CallButton className="d-block d-sm-none" link="tel:+4920452563" linktext={calltobutton} />
            <CallToButtonNeg className="d-block d-sm-none" link="/anfrage/" linktext="Zur Maßanfrage" />
          </Col>
          <Col md="6">
          <div style={{ height: '350px', width: '100%'}}>
          <GoogleMapReact
            bootstrapURLKeys={{ key: 'AIzaSyD5K5y4U-x0j3ac7FLxES8AgYcUf4g1XTc'}}
            defaultCenter= {map.center}
            defaultZoom = {map.zoom}
          >
            <AnyReactComponent
              lat={51.568305}
              lng={6.9140365}
              image={'Fischer Marmor GmbH'}
            />
          </GoogleMapReact>
        </div>
          </Col>
        </Row>
      </Fade>
      <Row>
        <Fade>
          <Col md="6" lg="10">
            <p className="contact__times">
              Geschäftszeiten Büro: {times.office}
              <br />
              {times.officesaturday}
              <br />
              Warenausgabe: {times.wares}
            </p>
          </Col>
        </Fade>
      </Row>
      <Row>
          <Col md="6" className="mt-5 mb-5">
            <ContactForm />
          </Col>
      </Row>
    </Container>
  );
};

const KontaktPage = ({ data }) => {
  const { frontmatter } = data.markdownRemark;
  const defaultProps = {
    center: {
      lat: 51.568305,
      lng: 6.9140365
    },
    zoom: 14
  };

  return (
    <KontaktPageTemplate
      title={frontmatter.title}
      description={frontmatter.description}
      heading={frontmatter.heading}
      address={frontmatter.adresse}
      calltobutton={frontmatter.calltobutton}
      times={frontmatter.times}
      map={defaultProps}
    />
  );
};

export default KontaktPage;

export const KontaktPageQuery = graphql`
  query KontaktPage($id: String!) {
    markdownRemark(id: { eq: $id }) {
      frontmatter {
        templateKey
        title
        heading
        description
        calltobutton
        adresse {
          name
          street
          postcode
          city
          phone
          fax
          mail
          website
        }
        times {
          office
          officesaturday
          wares
        }
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/templates/kontakt-page.js